import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import { ElMessage } from 'element-plus'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/home',
      name: '首页',
      meta: { title: '首页', icon: 'ele-HomeFilled' },
      component: () => import('../views/Home/index.vue')
    },
    {
      path: '/dashboard',
      name: '工作台',
      meta: { title: '工作台', icon: 'ele-Odometer' },
      component: () => import('../views/Expert/Dashboard.vue')
    },
    {
      path: '/expert',
      name: '专家信息管理',
      meta: { title: '专家信息管理', icon: 'ele-User' },
      component: () => import('../views/Expert/index.vue')
    },
    {
      path: '/expertAudit',
      name: '专家审核',
      meta: { title: '专家审核', icon: 'ele-EditPen' },
      component: () => import('../views/Expert/ExpertAudit.vue')
    },
    {
      path: '/reviewRecord',
      name: '评审记录',
      meta: { title: '评审记录', icon: 'ele-Document' },
      component: () => import('../views/Expert/ReviewRecord.vue')
    },
    {
      path: '/evaluation',
      name: '评价管理',
      meta: { title: '评价管理', icon: 'ele-Star' },
      component: () => import('../views/Expert/Evaluation.vue')
    },
    {
      path: '/expertTag',
      name: '专家标签维护',
      meta: { title: '专家标签维护', icon: 'ele-PriceTag' },
      component: () => import('../views/Expert/ExpertTag.vue')
    },
    {
      path: '/inspect',
      name: '检查总览',
      meta: { title: '检查总览', icon: 'ele-Grid' },
      component: () => import('../views/Inspect/OverviewPage.vue')
    },
    {
      path: '/inspect/criteria',
      name: '检查表管理',
      meta: { title: '检查表管理', icon: 'ele-Document' },
      component: () => import('../views/Inspect/CriteriaPage.vue')
    },
    {
      path: '/inspect/annual-plan',
      name: '年度全国检查',
      meta: { title: '年度全国检查', icon: 'ele-Guide' },
      component: () => import('../views/Inspect/AnnualPlanPage.vue')
    },
    {
      path: '/inspect/plans',
      name: '检查方案',
      meta: { title: '检查方案', icon: 'ele-Tickets' },
      component: () => import('../views/Inspect/PlanListPage.vue')
    },
    {
      path: '/inspect/activities',
      name: '检查活动',
      meta: { title: '检查活动', icon: 'ele-User' },
      component: () => import('../views/Inspect/ActivityPage.vue')
    },
    {
      path: '/inspect/self-check',
      name: '机构自查',
      meta: { title: '机构自查', icon: 'ele-UserFilled' },
      component: () => import('../views/Inspect/SelfCheckPage.vue')
    },
    {
      path: '/inspect/history',
      name: '历史记录',
      meta: { title: '历史记录', icon: 'ele-Clock' },
      component: () => import('../views/Inspect/HistoryPage.vue')
    },
    {
      path: '/inspect/rectification',
      name: '问题整改',
      meta: { title: '问题整改', icon: 'ele-Tools' },
      component: () => import('../views/Inspect/RectificationPage.vue')
    },
    {
      path: '/inspect/statistics',
      name: '数据统计',
      meta: { title: '数据统计', icon: 'ele-DataAnalysis' },
      component: () => import('../views/Inspect/StatisticsPage.vue')
    },
    {
      path: '/inspect/settings',
      name: '系统设置',
      meta: { title: '系统设置', icon: 'ele-Setting' },
      component: () => import('../views/Inspect/SettingsPage.vue')
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/home'
    }
  ]
})

// 专家库管理子系统路由：仅限白名单角色访问
const EXPERT_ROUTES = ['/dashboard', '/expert', '/expertAudit', '/reviewRecord', '/evaluation', '/expertTag']
const ALLOWED_EXPERT_ROLES = [
  'bio_center_expert',     // 专家角色
  'country_admin',         // 卫健角色（国家管理员）
  'province_admin',        // 卫健角色（省管理员）
  'bio_center',            // 生物中心机构角色
  'bio_center_leader',     // 生物中心组长角色
  'bio_center_member'      // 生物中心成员角色
]

router.beforeEach((to, from, next) => {
  if (EXPERT_ROUTES.includes(to.path)) {
    let sr = null
    try {
      sr = JSON.parse(localStorage.getItem('selectedRole') || 'null')
    } catch (e) {
      sr = null
    }
    const hasPermission = sr && ALLOWED_EXPERT_ROLES.includes(sr.id || sr)
    if (!hasPermission) {
      ElMessage.error('无权限访问专家库管理')
      return next({ path: '/home' })
    }
  }
  next()
})

export default router
